import * as Popover from "@radix-ui/react-popover";
import { AnimatePresence, motion } from "framer-motion";
import React, { useContext, useEffect, useRef, useState } from "react";
import { MdClose } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import clsxm from "../../context/clsxm";
import Color from "../../context/constants/Color";
import en from "./assets/en.svg";
import Expand from "./assets/Expand";
import ActiveItem from "./components/ActiveItem";
import MenuContext from "./MenuContext";
import styles from "./SSoft_Header.module.css";

export default function DesktopMenu() {
  const dispatch = useDispatch();
  const location = useLocation();
  const splitterUrl = location?.pathname.split("/");
  // const languages = useSelector((state) => state.content.languages);
  const languages = [
    {
      abbreviation: "en",
      flag: "GB",
      id: 1,
      is_default: true,
      name: "English",
    },
    {
      id: 3,
      abbreviation: "id",
      flag: "ID",
      name: "Indonesian",
      is_default: false,
    },
  ];

  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const menuContext = useContext(MenuContext);
  const { data, isSearch, menu } = menuContext;
  const [activeItem, setActiveItem] = useState({
    id: null,
    open: false,
    data: null,
    count: 0,
  });
  const [activeFill, setActiveFill] = useState(Color.white);
  const [activeLogo, setActiveLogo] = useState(null);
  const [isScrolling, setIsScrolling] = useState(false);
  const [isBlur, setIsBlur] = useState(false);
  const [isShowingDeepItem, setIsShowingDeepItem] = useState(false);
  const [isInitialize, setIsInitialize] = useState(false);

  const hoverTimeout = useRef(null);
  const menuContainerRef = useRef(null);

  const langElementActive = languages.filter(
    (lang) => lang.id === activeLanguage
  );

  const mainVariants = {
    hidden: { height: 0, top: -100, opacity: 0 },
    show: {
      height: 78,
      top: 0,
      opacity: 1,
      transition: { delay: 0, duration: 0.5, ease: "easeInOut" },
    },
  };

  const activeItemVariants = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: { delay: 0.3, duration: 0.3, ease: "easeInOut" },
    },
    exit: {
      opacity: 0,
      transition: { delay: 0, duration: 0.1, ease: "easeInOut" },
    },
  };

  const menuVariants = {
    initial: { height: 0, top: -464, opacity: 0 },
    animate: {
      height: 200,
      top: 0,
      opacity: 1,
      transition: { delay: 0, duration: 0.5, ease: "easeInOut" },
    },
    exit: {
      top: -464,
      opacity: 0,
      height: 0,
      transition: { delay: 0, duration: 0.5, ease: "linear" },
    },
  };

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (hoverTimeout.current) {
        clearTimeout(hoverTimeout.current);
      }
    };
  }, []);

  useEffect(() => {
    if (
      (data && isScrolling) ||
      (!isScrolling &&
        data &&
        activeItem.open &&
        activeFill !== Color.blackPrimary)
    ) {
      setTimeout(() => {
        setActiveFill(Color.blackPrimary);
        // setActiveLogo(data.logo[2] ? data.logo[2].file : logoColor);
      }, 100);
    }
  }, [isScrolling, data, activeItem.open, activeFill]);

  useEffect(() => {
    if (
      !isScrolling &&
      data &&
      !activeItem.open &&
      activeFill === Color.blackPrimary
    ) {
      setTimeout(() => {
        setActiveFill(Color.white);
        // setActiveLogo(
        //   data.logo[1] ? data.logo[1].file : data.logo[2].file || logoWhite
        // );
      }, 100);
    }
  }, [isScrolling, data, activeItem.open, activeFill]);

  useEffect(() => {
    if (!isInitialize && data) {
      // if (window.scrollY > 0) {
      //   setIsScrolling(true);
      // } else {
      //   setActiveLogo(
      //     data.logo[1] ? data.logo[1].file : data.logo[2].file || logoWhite
      //   );
      // }
      setIsInitialize(true);
    }
  }, [isInitialize, data]);

  //* Scrolling event
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0 && !isScrolling) {
        setIsScrolling(true);
      }
      if (window.scrollY === 0) {
        setIsScrolling(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolling]);

  const handleActiveMenu = ({ id, open, data }) => {
    setIsBlur(false);

    setIsShowingDeepItem(false);
    setActiveItem({ id, open: !activeItem.open, data, count: 1 });
    if (activeItem.id === id && activeItem.open === true) {
      setActiveItem({ id: null, open: false });
      setTimeout(() => {
        setIsBlur(false);
      }, 200);
    } else {
      setActiveItem({ id, open: true, data });
      setTimeout(() => {
        setIsBlur(true);
      }, 200);
    }
  };

  const handleOpenMenu = (item) => {
    if (!item.children) return;
    menuContext.setIsSearch(false);
    setActiveItem({ id: item.id, open: true, data: item });
    setTimeout(() => setIsBlur(true), 200);
  };

  const handleCloseMenu = () => {
    setActiveItem({ id: null, open: false, data: null });
    setTimeout(() => setIsBlur(false), 200);
  };

  return (
    <>
      <div
        ref={menuContainerRef}
        id="tbs-navigation"
        className="relative w-full h-full xl:block hidden "
        onMouseLeave={() => {
          // Only close if mouse is truly outside the whole menu area
          if (hoverTimeout.current) clearTimeout(hoverTimeout.current);
          hoverTimeout.current = setTimeout(() => {
            if (
              menuContainerRef.current &&
              !menuContainerRef.current.matches(":hover")
            ) {
              handleCloseMenu();
            }
          }, 150);
        }}
      >
        <AnimatePresence>
          {data && isInitialize && (
            <>
              <motion.div
                className={[
                  styles.dsktpContainer,
                  "w-full bg-white h-[78px] z-[10000] border-b border-[#DEDEDE] ",
                ].join(" ")}
                initial="hidden"
                animate="show"
                variants={mainVariants}
              >
                <div
                  className={[
                    `section-container section-margin-x relative h-full flex items-center z-[10000]`,
                  ].join(" ")}
                >
                  <div className="flex justify-between w-full">
                    <div className="h-full flex items-center space-x-16 ">
                      <Link to="/" onClick={() => setActiveItem(false)}>
                        <div className="flex items-center w-[206px]">
                          <img
                            src={data?.logo[0]?.file}
                            className="  w-full hs-[45px]"
                            alt="supersoft logo"
                          />
                        </div>
                      </Link>
                      <div className=" flex items-center space-x-8  ">
                        {menu?.map((itm) => {
                          const getIdCurrentPath =
                            splitterUrl && splitterUrl.length > 0
                              ? itm?.title
                                  .replace(/\s+/g, "-")
                                  .toLowerCase() === splitterUrl[1]
                              : "";
                          const contentHtml = (
                            <div
                              className={[
                                " flex items-center text-black fhd:text-[18px] text-[16px] font-semibold ",
                              ].join(" ")}
                            >
                              <div
                                className={clsxm(
                                  "mr-[10px]  transition-all ",
                                  getIdCurrentPath
                                    ? "text-[#E12726] border-b-2 border-[#E12726] "
                                    : "hover:text-[#E12726]  border-b-2 border-white hover:border-[#E12726] "
                                )}
                              >
                                {itm.title}
                              </div>
                              {itm?.children && (
                                <Expand
                                  fill="#000000"
                                  className="text-black "
                                />
                              )}
                            </div>
                          );
                          const contentLink = (
                            <Link
                              className={clsxm(
                                "fhd:text-[18px] text-[16px] font-semibold transition-all ",
                                getIdCurrentPath
                                  ? "text-[#E12726] border-b-2 border-[#E12726] "
                                  : "hover:text-[#E12726]  border-b-2 border-white hover:border-[#E12726] "
                              )}
                              to={itm.url || "/"}
                            >
                              {itm.title}
                            </Link>
                          );
                          let html = (
                            <button
                              key={itm.title}
                              className={[
                                "h-[70px] flex items-center cursor-pointer",
                                activeItem?.data?.title === itm.title &&
                                  styles.dsktpItmActive,
                                !activeItem?.data?.title &&
                                  isSearch &&
                                  styles.dsktpItmActiveS,
                              ].join(" ")}
                              onMouseEnter={() => {
                                if (hoverTimeout.current) {
                                  clearTimeout(hoverTimeout.current);
                                }
                                // Open after short delay
                                hoverTimeout.current = setTimeout(() => {
                                  handleOpenMenu(itm);
                                }, 100);
                              }}
                              onMouseLeave={() => {
                                // Schedule close, but it may be canceled
                                if (hoverTimeout.current) {
                                  clearTimeout(hoverTimeout.current);
                                }
                                hoverTimeout.current = setTimeout(() => {
                                  if (
                                    menuContainerRef.current &&
                                    !menuContainerRef.current.matches(":hover")
                                  ) {
                                    handleCloseMenu();
                                  }
                                }, 150);
                              }}
                            >
                              {itm?.children ? contentHtml : contentLink}
                            </button>
                          );

                          return html;
                        })}
                      </div>
                    </div>
                    <div className="flex items-center space-x-[15px]">
                      <Popover.Root>
                        <Popover.Trigger asChild>
                          <button className="flex items-center cursor-pointer ">
                            {/* <div className="">{langElementActive[0].flag}</div> */}
                            <img
                              src={
                                activeLanguage !== 1
                                  ? data?.lang_icon[1]?.file
                                  : data?.lang_icon[0]?.file
                              }
                              alt=""
                              className="rounded-full w-4 h-4 shadow"
                            />
                            <div className="mr-[12px] fhd:text-[18px] text-[16px] font-[500] ml-[9px] hover:text-[#E12726]  border-b-2 border-white hover:border-[#E12726] transition-all  ">
                              {langElementActive?.[0]?.name || "ID"}
                            </div>
                            <Expand fill="#000000" className="" />
                          </button>
                        </Popover.Trigger>
                        <Popover.Portal>
                          <Popover.Content
                            className="PopoverContent"
                            sideOffset={5}
                          >
                            <div className="flex py-2 px-4">
                              <div className="flex flex-col space-y-2 items-start">
                                {languages.map((l) => {
                                  const isActive =
                                    activeLanguage && l.id === activeLanguage;
                                  const activeStyle = isActive
                                    ? "text-black font-semibold"
                                    : "text-black";
                                  return (
                                    <button
                                      key={l.name}
                                      onClick={() => {
                                        if (window.location.hash) {
                                          window.history.replaceState(
                                            "",
                                            document.title,
                                            window.location.pathname
                                          );
                                        }
                                        if (!isActive) {
                                          dispatch({
                                            type: "content/setActiveLanguage",
                                            payload: l,
                                          });
                                        }
                                      }}
                                    >
                                      <div
                                        className={[
                                          activeStyle,
                                          "cursor-pointer  flex items-center space-x-2",
                                        ].join(" ")}
                                      >
                                        <img
                                          src={
                                            l.id !== 1
                                              ? data?.lang_icon[1]?.file
                                              : data?.lang_icon[0]?.file
                                          }
                                          alt=""
                                          className="rounded-full w-4 h-4 shadow"
                                        />
                                        <span className="hover:text-[#E12726]  border-b-2 border-white hover:border-[#E12726] transition-all">
                                          {l.name}
                                        </span>
                                      </div>
                                    </button>
                                  );
                                })}
                              </div>
                            </div>

                            <Popover.Close
                              className="PopoverClose text-cuzRed hover:bg-cuzRed/20 focus:outline-none focus:border-none"
                              aria-label="Close"
                            >
                              <MdClose className="text-cuzRed" />
                            </Popover.Close>
                            <Popover.Arrow className="PopoverArrow" />
                          </Popover.Content>
                        </Popover.Portal>
                      </Popover.Root>

                      <Link
                        to={data?.language[0]?.article_language?.path || "/"}
                        className=""
                      >
                        <div className="  all-button bg-[#255262] ">
                          {data?.language[0]?.article_language?.title}
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
                <AnimatePresence>
                  {activeItem.open && (
                    <motion.div
                      className={[
                        "absolute top-[78px] w-full bg-white z-[9999]",
                        styles.dsktpActiveContainer,
                      ].join(" ")}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      variants={menuVariants}
                    >
                      <motion.div
                        variants={activeItemVariants}
                        className="w-full h-auto relative mt-[78px]"
                      >
                        {/* <Reveal when={isReaveal}> */}
                        <ActiveItem
                          data={data}
                          item={activeItem?.data}
                          action={setActiveItem}
                          isShowingDeepItem={isShowingDeepItem}
                          setIsShowingDeepItem={setIsShowingDeepItem}
                          setActiveItem={setActiveItem}
                        />
                        {/* </Reveal> */}
                      </motion.div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </div>
      {isBlur && (
        <div className="fixed h-[100%] w-[100%] z-[2000] animate-in fade-in bg-black/50"></div>
      )}
    </>
  );
}
